import React from 'react';
import { Box } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { CreativeDecisionRefreshDraftPage } from '../components/importRefresh/CreativeDecisionRefreshDraftPage';
import { parseCreativeDecisionRefreshHandoff } from '../components/importRefresh/creativeDecisionRefreshHandoff';
import { AdCreativeApiClient } from '../services/AdCreativeApiClient';
import { AD_CREATIVE } from '../selectors';

/**
 * Minimal Funnel Insights-owned destination for a Creative Decisions refresh
 * handoff. It intentionally avoids mounting the full Content Plan / Ad Creative
 * workspace, so connected-account users only load the reviewed draft surface.
 */
export function CreativeDecisionRefreshRoutePage(): React.ReactElement {
  const { projectId = '' } = useParams<{ projectId: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const client = React.useMemo(() => new AdCreativeApiClient(), []);
  const parseResult = React.useMemo(
    () => parseCreativeDecisionRefreshHandoff(searchParams),
    [searchParams],
  );

  return (
    <Box
      data-testid={AD_CREATIVE.page}
      sx={{ p: { xs: 1, sm: 2, md: 3 }, maxWidth: 1480, mx: 'auto' }}
    >
      <CreativeDecisionRefreshDraftPage
        projectId={projectId}
        client={client}
        parseResult={parseResult}
        onBack={() => navigate(`/project/${encodeURIComponent(projectId)}/reports/creative-decisions`)}
        onOpenBatch={(briefId) => navigate(
          `/project/${encodeURIComponent(projectId)}/content-plan/creatives?batch=${encodeURIComponent(briefId)}&step=briefs`,
        )}
      />
    </Box>
  );
}
